import { z } from 'zod';
import { FORM_FIELD_LIMITS } from '@/shared/utils/form-field-limits';

/** Minimal translation function shape used by the schema: resolves a key to a message. */
type TranslateFn = (key: string) => string;

/**
 * Builds the visit form zod schema with localized validation messages.
 *
 * @param t - Translator resolving a validation message key to a string.
 * @returns The zod object schema for the visit form.
 */
export function createVisitSchema(t: TranslateFn) {
  return z.object({
    propertyId: z.string().min(1, { message: t('schema.selectProperty') }),
    clientId: z.string().min(1, { message: t('schema.selectClient') }),
    /** Empty means "open a new attendance" — the flat route does that. */
    dealId: z.string().default(''),
    visitDate: z.string().min(1, { message: t('schema.selectDate') }),
    visitTime: z.string().min(1, { message: t('schema.selectTime') }),
    brokerEmail: z
      .string()
      .min(1, { message: t('schema.invalidEmail') })
      .email({ message: t('schema.invalidEmail') }),
    notes: z.string().max(FORM_FIELD_LIMITS.notes).default(''),
  });
}

/** Default schema for non-i18n contexts (unit tests); messages are i18n keys. */
export const visitSchema = createVisitSchema((key: string) => key);

export type VisitFormData = z.infer<ReturnType<typeof createVisitSchema>>;

export const TIME_SLOTS = [
  '08:00', '08:30', '09:00', '09:30', '10:00', '10:30',
  '11:00', '11:30', '12:00', '12:30', '13:00', '13:30',
  '14:00', '14:30', '15:00', '15:30', '16:00', '16:30',
  '17:00', '17:30', '18:00',
] as const;
